

























































































































import { Component, Vue } from 'vue-property-decorator';
import RegisterActivity from '@/components/RegisterActivity.vue'; 
import { db, userData } from '../main';

Vue.component('RegisterActivity', RegisterActivity);

@Component
export default class ActivityList extends Vue {
  self = this;
  current = 0;

  public data() {
    return {
      name: userData.user.name,
      challenge: userData.challenge,
      userData: userData,
      userId: this.$route.params.userId,
      props: ['userId']
    };
  }

  public more() {
    if (userData.entriesData.entries.length > (this.current + 1) * 10)
      this.current++;
  }

  public less() {
    if (this.current > 0)
      this.current--;
  }

  get pagedEntries() {
    return userData.entriesData.entries.slice(this.current * 10, this.current * 10 + 10);
  }

  public confirmRemove(entry: any) {
      this.$dialog.confirm({
          title: 'Ta bort aktivitet',
          message: 'Är du säker på att du vill <b>ta bort</b> aktivitet? Kan inte ångras.',
          confirmText: 'Ta bort',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.remove(entry)
      });
  }

  public remove(entry: any) {
    const that = this;
    db.collection('entries').doc(entry.id).delete().then(() => {
      this.updateUserStats(entry);
      that.$toast.open('Aktivitet borttagen!');
    }).catch((error) => {
      that.$toast.open('Error removing document: ' + error);
    });
  }
  
  public elipsedLink(link: string) {
    const maxLength = 32;
    let shortened = link.replace('http://','').replace('https://','').replace('www.', '');
    if(shortened.length > maxLength)
      return shortened.substring(0, maxLength) + '...';
    return shortened;
  }

  private updateUserStats(act) {
      // Ugly hack because FB is slow to propagate 
      const stats = userData.statsData.userStats.find(x => x.uid == act.uid);
      if(stats) {
          stats.totalPoints -= act.points;
          stats.totalKcal -= Number(act.kcal);
          stats.totalMinutes -= Number(act.minutes);
          stats.totalNumber -= 1;
      }
  }

  public comment(entry: any) {
    this.$dialog.prompt({
        message: 'Skriv din kommentar',
        inputAttrs: {
            placeholder: '',
            maxlength: 200,
        },
        confirmText: 'Skicka',
        cancelText: 'Avbryt',
        onConfirm: (comment) => {
          userData.saveComment(comment, entry);
        }
    });
  }

  get isLoggedInUser() {
    return this.$data.userData.user.id === this.$route.params.userId;
  }

  public mounted() {
    if (!userData.challenge.id.length) {
      userData.loadChallenges().then(() => {
        userData.loadEntries(this.$route.params.userId);
      });
    } else {
        userData.loadEntries(this.$route.params.userId);
    }
  }
}
